import { MenuItem } from '@qualtrics/ui-react';
import { getTier1DataTestId } from '../../../Service/testing';
import styles from '../account-menu.scss';
import { messageService } from '../../../Service/message-service';
import React from 'react';

export const getRefreshAccount = (refreshAccount) => {
  return (
    <MenuItem
      onSelect={refreshAccount}
      data-testid={getTier1DataTestId('Account-Menu-RefreshAccount')}
      className={styles.menuItemPortals}
      key={getTier1DataTestId('Account-Menu-RefreshAccount')}
    >
      {messageService.get('REFRESH_ACCOUNT')}
    </MenuItem>
  );
};
